import { setupMfaAmplifyConverter } from 'data/converters';
import { TAmplifySetupMfaData, TSetupMfaData, TSetupMfaDataUi } from 'data/types/auth.types';
import { verifyCodeAmplifyService } from 'api/services/authServices';
import useApiResult from './useApiResult';

export const useVerifyCode = (
  onSuccess?: (data: boolean) => void,
  onFail?: (err: Error) => void,
) => {
  return useApiResult<
    TSetupMfaDataUi,
    TSetupMfaData,
    boolean,
    TAmplifySetupMfaData
  >(verifyCodeAmplifyService, setupMfaAmplifyConverter, onSuccess, onFail);
};